import { systemNotifications } from "../constants/commonConstants";

const payNowMessageConfig = {
  button: "Pay Now",
  action: () => console.log("Pay Now clicked"),
};

const messageConfig = {
    "Your order has been successfully created.": {
      button: null,
    },
    "Your order requirements have been submitted.": {
      button: "View Requirements",
      action: () => console.log("View Requirements clicked"),
    },
    [systemNotifications.PENDING_PAYMENT]: payNowMessageConfig,
    "Your order is waiting for your payment. Please complete the payment to proceed.": payNowMessageConfig,
    "Your order is pending payment. Please complete the payment to proceed.": payNowMessageConfig,
    "Your order has been created. Please complete payment to continue.": payNowMessageConfig,
    "Your order is a draft. Please complete the payment to proceed.": payNowMessageConfig,
    "Your Order is now in progress.": {
      button: null,
    },
    "Your order has been delivered. Please review and accept the delivery.": {
      button: "Review Order",
      action: () => console.log("Review Order clicked"),
    },
    "Your order has been marked as completed. Thank you for using our service.": {
      button: null,
    },
    [systemNotifications.ORDER_AUTO_ACCEPTED]: {
      button: null,
    },
    "Your order has been marked as completed by the admin. Thank you for using our service": {
      button: null,
    },
    "Your complaint has been received. We will review it and respond shortly.": {
      button: "View Complaint",
      action: () => console.log("View Complaint clicked"),
    },
    "Your complaint has been resolved.": {
      button: null,
    },
    "Your Review has been received. We will review it and respond shortly. .": {
      button: "View Revision",
      action: () => console.log("View Revision clicked"),
    },
    "Your Review has been done. Thank you for your patience.": {
      button: null,
    },
  };
  
  export default messageConfig;
  
